import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CiLock } from "react-icons/ci";

const SideBar = ({ onToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(true);

  const permissions = JSON.parse(localStorage.getItem("userPermissions"));
  const userRole = localStorage.getItem("role");
  const isAdmin = userRole === "admin";

  useEffect(() => {
    if (onToggle) onToggle(true);
  }, [userRole]);

  const toggleDrawer = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (onToggle) onToggle(newState);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const menuList = [
    {
      name: "Calls",
      path: "/dashboard",
      icon: !isAdmin && !permissions?.call_logs?.view ? <CiLock /> : null,
    },
    {
      name: "Incoming Calls",
      path: "/incoming-calls",
      icon: !isAdmin && !permissions?.call_logs?.view ? <CiLock /> : null,
    },
    {
      name: "User",
      path: "/nid-verification",
      icon: !isAdmin && !permissions?.nid_verifications?.view ? <CiLock /> : null,
    },
    // {
    //   name: "User Balance",
    //   path: "/user-balance",
    //   icon: !isAdmin && !permissions?.user_balance?.view ? <CiLock /> : null,
    // },
    {
      name: "Recharge History",
      path: "/recharge-history",
      icon: !isAdmin && !permissions?.recharge_history?.view ? <CiLock /> : null,
    },
    {
      name: "User Account",
      path: "/user-account",
      icon: !isAdmin && !permissions?.user_account?.view ? <CiLock /> : null,
    },
    {
      name: "SIP Trunks",
      path: "/sip-trunks",
      icon: !isAdmin && !permissions?.sip_trunks?.view ? <CiLock /> : null,
    },
    {
      name: "User Sessions",
      path: "/user-sessions",
      icon: !isAdmin && !permissions?.user_sessions?.view ? <CiLock /> : null,
    },
    {
      name: "Rate Sheets",
      path: "/rate-sheets",
      icon: !isAdmin && !permissions?.rate_sheets?.view ? <CiLock /> : null,
    },
    {
      name: "Stickers",
      path: "/stickers",
      icon: !isAdmin && !permissions?.stickers?.view ? <CiLock /> : null,
    },
    {
      name: "Chat Reports",
      path: "/chat-reports",
      icon: !isAdmin && !permissions?.chat_reports?.view ? <CiLock /> : null,
    },
    {
      name: "Account Deletions",
      path: "/account-deletion-requests",
      icon: !isAdmin && !permissions?.account_deletion_requests?.view ? <CiLock /> : null,
    },
    {
      name: "Service Numbers",
      path: "/service-numbers",
      icon: !isAdmin && !permissions?.service_numbers?.view ? <CiLock /> : null,
    },
  ];

  return (
    <>
      {!isOpen && (
        <button className="drawer-toggle-btn" onClick={toggleDrawer}>
          Menu
        </button>
      )}

      <div className={`drawer ${isOpen ? "drawer-open" : ""}`}>
        <div className="drawer-header">
          <h5 className="drawer-title">Menu</h5>
          <button className="drawer-close-btn" onClick={toggleDrawer}>
            ×
          </button>
        </div>

        <div className="drawer-body">
          <ul className="drawer-menu">
            {menuList.map((item) => {
              const isDisabled = Boolean(item.icon);

              return (
                <li
                  key={item.path}
                  className={`drawer-item ${
                    location.pathname === item.path ? "active" : ""
                  } ${isDisabled ? "disabled" : ""}`}
                  onClick={() => {
                    if (!isDisabled) handleNavigation(item.path);
                  }}
                >
                  <span>{item.name}</span>
                  {isDisabled && (
                    <span className="menu-icon">{item.icon}</span>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideBar;
